<template>
  <div>
    <div class="py-5 text-white bg-gray-charcoal">

      <div class="container flex flex-wrap items-center justify-start text-xl">

        <p>What's happening at</p>

        <div class="relative w-full my-3 select-wrapper md:mx-4 md:w-auto md:my-0">
          <button class="font-medium underline bg-transparent appearance-none event-category-selector" data-toggle-target=".events-categories-area, .events-archive-area" data-toggle-class="is-active" data-toggle-escape data-toggle-outside>{{ selectedLocationName }} <svg class="ml-2 text-base icon icon-medium-chevron-down" aria-hidden="true"><use xlink:href="#icon-medium-chevron-down"></use></svg></button>

          <div class="events-categories-area">

            <ul class="px-6 py-4">

              <li class="text-base font-medium border-b border-gray-text last:border-b-0">
                <button @click="selectLocation( false )" class="inline-flex items-center py-2 pl-4" :class="{'is-active': ! selectedLocation }"><span class="flex-shrink-0 bg-white color-block"></span>Any Location</button>
              </li>

              <li v-for="(location, index) in locations" :key="index" class="text-base font-medium border-b border-gray-text last:border-b-0">
                <button @click="selectLocation( location )" class="inline-flex items-center py-2 pl-4 text-left" :class="{'is-active': selectedLocation && selectedLocation.term_id === location.term_id }"><span :class="locationClasses( location )"></span>{{ location.name }}</button>
              </li>

            </ul>

          </div>

        </div>

        <span>on</span>

        <div class="relative ml-4">

          <button class="font-medium underline bg-transparent appearance-none event-date-selector" data-toggle-target=".events-calendar-area, .events-archive-area" data-toggle-class="is-active" data-toggle-escape data-toggle-outside>{{ formatDisplayDate() }} <svg class="ml-2 text-base icon icon-medium-chevron-down" aria-hidden="true"><use xlink:href="#icon-medium-chevron-down"></use></svg></button>

          <div class="pt-4 events-calendar-area">

            <div class="events-search__calendar">
              <date-picker v-model="date" :min-date="new Date()" is-expanded trim-weeks is-required/>
            </div>

          </div> <!-- /.events-calendar-area -->

        </div> <!-- /.relative -->

      </div> <!-- /.container -->

    </div> <!-- /.bg-gray-charcoal -->


    <div class="pb-14 bg-gray-light-gray events-archive-area" role="region">

      <div id="live-region" aria-live="polite" aria-atomic="true" class="sr-only">{{ message }}</div>

      <div class="container">

        <div class="row">

          <template v-if="isRunning">

            <div class="w-full col mt-14">

              <p class="hdg-5">Loading events...</p>

            </div> <!-- /.col -->

          </template>

          <template v-else>

            <template v-if="events.length">

              <div v-for="(event, index) in events" :key="index" class="w-full col md:w-1/2 lg:w-1/3 mt-14">

                <article class="relative flex flex-col justify-start h-full card">

                  <div class="relative flex-initial">

                    <div class="relative image-wrapper aspect-2/1" v-html="event.image">
                    </div> <!-- /.image-wrapper -->

                  </div> <!-- /.relative -->

                  <div class="flex flex-col justify-between flex-1 px-6 py-5 bg-white content">

                    <div class="flex-initial">

                      <div v-if="event.terms" class="flex items-start justify-start">

                        <span v-for="(term, index) in event.terms" :key="index" :class="'text-sm font-medium mr-3 mb-1 flex-initial ' + term.color">{{ term.name }}</span>

                      </div> <!-- /.flex -->

                      <h2 class="mt-2 hdg-4"><a :href="event.url" class="z-20 hover:underline link-after">{{ event.name }}</a></h2>

                      <p v-if="event.info" class="mt-3">{{ event.info }}</p>

                    </div> <!-- /.flex-initial -->

                    <div class="flex flex-wrap items-center justify-between flex-initial mt-12">

                      <p aria-hidden="true" class="mb-4 font-medium xl:mb-0">Learn more</p>

                      <template v-if="event.ticketure">
                        <!-- <button :data-id="event.post_id" class="buy-tickets-trigger btn-black-border" :title="'Buy tickets for ' + event.name">Buy Tickets</button> -->
                        <a :href="event.ticketure_url" class="relative btn-black-border" :title="'Buy tickets for ' + event.name" target="_blank">Buy Tickets</a>
                      </template>

                      <template v-else>
                        <p  class="btn-black-border btn-event-buy-ticket">Buy Tickets</p>
                      </template>

                    </div> <!-- /.text-right -->

                  </div> <!-- /.content -->

                </article> <!-- /.card -->

              </div> <!-- /.col -->

            </template>

            <template v-else>

              <div class="w-full col mt-14">

                <p class="hdg-5">No events found for this date.</p>

              </div> <!-- /.col -->

            </template>

          </template>

        </div> <!-- /.row -->

          <!-- if ($wp_query->max_num_pages > 1) :
          <nav class="mt-16 text-center pagination">
            echo paginate_links( array(
              'type' => 'list',
              'prev_next' => true,
              'format'  => 'page/%#%',
              'current' => max( 1, get_query_var('paged') ),
              'total'   => $wp_query->max_num_pages,
              'mid_size'        => 5,
              'before_page_number' => '<span class="sr-only">Page</span>',
              'prev_text'       => __('<svg class="icon icon-chevron-left" aria-hidden="true"><use xlink:href="#icon-chevron-left"></use><span class="sr-only">Previous page</span></svg>'),
              'next_text'       => __('<svg class="icon icon-chevron-right" aria-hidden="true"><use xlink:href="#icon-chevron-right"></use></svg><span class="sr-only">Next page</span>')
            ) );
          </nav>
          endif; -->

      </div> <!-- /.container -->

    </div> <!-- /.py-14 -->

  </div>
</template>

<script>
export default {
  props: [ 'locations' ],
  data() {
    return {
      isRunning: false,
      selectedLocation: false,
      date: new Date(),
      events: [],
      message: '',
    };
  },
  mounted() {
    const _this = this;
    _this.getEvents();
  },
  methods: {
    getEvents: function() {
      const _this = this;

      if ( ! _this.isRunning ) {
        _this.isRunning = true;

        $.post(
          site_info.ajax_url,
          {
            action: 'll_run_function',
            function: 'get_events_by_category_and_date',
            params: {
              category: _this.selectedLocation,
              date: _this.formatDate(),
            }
          },
          function(data, textStatus, xhr) {
            data = $.parseJSON( data );

            if ( data.status === 'success' ) {
              _this.events = data.response;
              let locationText = _this.selectedLocation ?  _this.selectedLocation : 'any location';
              _this.message = 'Events on ' + _this.formatDisplayDate() + ' at ' + locationText  + ' loaded';
              _this.isRunning = false;
            }
          }
        );
      }
    },
    selectLocation: function( location ) {
      const _this = this;
      _this.selectedLocation = location;
      $( '.event-category-selector' ).click();
      _this.getEvents();
    },
    formatDisplayDate: function() {
      const _this = this;
      let month = '' + (_this.date.getMonth() + 1);
      let day = '' + _this.date.getDate();
      const year = _this.date.getFullYear();

      if ( month.length < 2 ) {
        month = '0' + month;
      }

      if ( day.length < 2 ) {
        day = '0' + day;
      }

      return [month, day, year].join('.');
    },
    formatDate: function() {
      const _this = this;
      let month = '' + (_this.date.getMonth() + 1);
      let day = '' + _this.date.getDate();
      const year = _this.date.getFullYear();

      if ( month.length < 2 ) {
        month = '0' + month;
      }

      if ( day.length < 2 ) {
        day = '0' + day;
      }
      return [year, month, day].join('-');
    },
    locationClasses: function( location ) {
      const _this = this;
      return 'color-block flex-shrink-0 ' + location.color;
    },
  },
  watch: {
    date: function( newValue, oldValue ) {
      const _this = this;
      $( '.event-date-selector' ).click();

      if ( _this.isRunning ) {
        _this.date = oldValue;
      } else {
        _this.getEvents();
      }
    },
  },
  computed: {
    selectedLocationName: function() {
      const _this = this;
      if ( _this.selectedLocation ) {
        return _this.selectedLocation.name;
      } else {
        return 'Any Location';
      }
    }
  },
};
</script>
